export type LivePrompt = {
  name: string
  description: string
  role?: string | null
  engineVersion?: string | null
  usage?: string
  aiModel?: string
  responseSchema?: unknown
}

/** The shared (role-less) row of one prompt on one layer — `null` layer is BASE. */
export function findSharedPrompt(
  prompts: LivePrompt[],
  name: string,
  layer: string | null
): LivePrompt | undefined {
  return prompts.find(
    (prompt) =>
      prompt.name === name &&
      !prompt.role &&
      (prompt.engineVersion ?? null) === layer
  )
}
